// @flow
import { useCallback, useContext, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import DropdownList from 'react-widgets/lib/DropdownList';
import _includes from 'lodash/includes';

import { BandStateContext } from '@contexts/band';

import ListItem from '@components/productDetail/ring_size_selector/ListItem';
import ValueInput from '@components/productDetail/ring_size_selector/ValueInput';

import css from '@styles/productDetail/ringSizeSelector';

import type { TBandDetail } from '@types/band';

type TProps = {
  band: TBandDetail
};

const SelectIcon = <span aria-hidden='true' />;

function RingSizeSelector({ band, onChange }: TProps) {
  const dispatch = useDispatch();
  const preferredRingSize = useSelector(
    state => state.ringSize.preferredRingSize
  );

  const { vendor_sku: bandSku } = band;
  const { other_available_sizes: sizes } = band;

  const handleChange = useCallback(selected => {
    dispatch({ type: 'SET_PREFERRED_RING_SIZE', payload: selected[0] });
    onChange(selected);
  });

  const isSingleSizePerSkuItem = sizes.filter(size => size[1] === band.vendor_sku).length === 1;
  const useableDefault = isSingleSizePerSkuItem
    ? sizes.find(size => size[1] === band.vendor_sku) // default to the size that the SKU is
    : sizes.find(size => size[0] === preferredRingSize);

  useEffect(() => {
    // we need to set the default value in state
    if (useableDefault) onChange(useableDefault);
  }, []);

  if (bandSku && sizes && sizes.length) {
    return (
      <DropdownList
        className={css.container}
        data={[[0, 'I DONT KNOW'], ...sizes]} // 0 is important because it is falsey
        itemComponent={ListItem}
        valueComponent={ValueInput}
        selectIcon={SelectIcon}
        onChange={handleChange}
        defaultValue={useableDefault}
      />
    );
  } else {
    return null;
  }
}

function RingSizeSelectorContainer({ onChange }) {
  const { band }: { band: TBandDetail } = useContext(BandStateContext);

  if (band.vendor_sku && band.other_available_sizes) {
    return <RingSizeSelector band={band} onChange={onChange} />;
  } else {
    return null;
  }
}

export default RingSizeSelectorContainer;
